import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { format } from 'date-fns';

const DeleteConfirmationModal = ({ open, onClose, onConfirm, visit }) => {
    const formattedVisitDate = visit?.visit_date ? format(new Date(visit.visit_date), 'dd.MM.yyyy') : 'Unknown date';

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
                Are you sure you want to delete the visit on <strong>{formattedVisitDate}?</strong>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm} variant="contained" color="secondary">Delete</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationModal;
